// src/delivery/index.js
// Delivery — extracted from index.html (v105.x sprint, auto-generated header).
// Bundled by esbuild into dist/delivery.js. The HTML loads it via
//   <script src="dist/delivery.js"></script>
// and call sites use `Delivery.<sub>.<fn>()` (e.g.
//   Delivery.schedule.loadDeliveryFromDB()
// ).
//
// Backwards compat: index.html's trailing script block re-exposes the
// moved functions on window so existing call sites — both inline JS and
// onclick="" attributes — keep working without HTML edits.
//
// Free variables (DB, currentUser, currentStore, escapeHtml, WORKER_URL,
// fetch, console, document, window, ...) live in the inline globals
// scope of index.html. esbuild leaves them as bare references at runtime.

// ── schedule ─────────────────────────────────────────────
export const schedule = {};

async function loadDeliveryFromDB() {
  if (typeof DB === 'undefined') return;
  try {
    var rows = await DB.delivery.list(currentStore);
    if (!Array.isArray(rows) || !rows.length) return;
    // Map full day name → 3-letter abbreviation
    var dayMap = {Monday:'Mon',Tuesday:'Tue',Wednesday:'Wed',Thursday:'Thu',Friday:'Fri',Saturday:'Sat',Sunday:'Sun'};
    // Reset deliveries
    deliveries = {};
    rows.forEach(function(r){
      var dayKey = dayMap[r.day_of_week || r.day] || r.day;
      if (!dayKey) return;
      if (!deliveries[dayKey]) deliveries[dayKey] = [];
      // v78: trim trailing :SS — Postgres TIME columns serialize as "HH:MM:SS"
      // but delivery windows only need minute precision. slice(0,5) is a
      // no-op for already-short strings.
      var startStr = (r.window_start || r.windowStart || '').slice(0, 5);
      var endStr   = (r.window_end   || r.windowEnd   || '').slice(0, 5);
      var timeStr = startStr + '-' + endStr;
      if (timeStr === '-') timeStr = '';
      deliveries[dayKey].push({
        time: timeStr,
        note: r.notes || r.note || ''
      });
    });
    dlog('[DB] Loaded deliveries for ' + currentStore + ': ' + Object.keys(deliveries).length + ' days');
    // Re-render rota if it's visible
    if (currentScreen === 'rota') renderCurrentRotaView();
  } catch(e) {
    console.warn('[DB] Delivery load failed:', e.message);
  }
}
schedule.loadDeliveryFromDB = loadDeliveryFromDB;

function openDeliveryModal(day){
  editingDeliveryDay=day;
  document.getElementById('deliveryModalTitle').textContent='Delivery \u2014 '+DAY_FULL[day];
  document.getElementById('deliveryModalDay').textContent='Set the delivery window for '+DAY_FULL[day];
  document.getElementById('delivStart').value='07:00';document.getElementById('delivEnd').value='09:00';document.getElementById('delivNote').value='';
  var existing=deliveries[day]||[];
  var existEl=document.getElementById('existingDeliveries');var listEl=document.getElementById('existingDelivList');
  listEl.innerHTML='';
  if(existing.length){
    existEl.style.display='block';
    existing.forEach(function(d,i){
      var row=document.createElement('div');row.style.cssText='display:flex;align-items:center;gap:6px;margin-bottom:5px';
      var pill=document.createElement('span');pill.className='delivery-pill';pill.setAttribute('translate','no');pill.textContent=d.time+(d.note?' \u2014 '+d.note:'');
      var rmBtn=document.createElement('button');rmBtn.style.cssText='background:none;border:none;color:var(--rota-red-ink);cursor:pointer;font-size:12px';rmBtn.textContent='\u2715';rmBtn.setAttribute('aria-label','Remove delivery');
      (function(dy,idx){rmBtn.addEventListener('click',function(){removeDelivery(dy,idx);});})(day,i);
      row.appendChild(pill);row.appendChild(rmBtn);listEl.appendChild(row);
    });
  }else existEl.style.display='none';
  document.getElementById('deliveryModal').classList.add('open');
}
schedule.openDeliveryModal = openDeliveryModal;

function closeDeliveryModal(){document.getElementById('deliveryModal').classList.remove('open');editingDeliveryDay=null;}
schedule.closeDeliveryModal = closeDeliveryModal;

function saveDelivery(){
  var day=editingDeliveryDay;
  var start=document.getElementById('delivStart').value;
  var end=document.getElementById('delivEnd').value;
  var note=document.getElementById('delivNote').value.trim();
  if(!start||!end){showToast('Set a start and end time','error');return;}

  // Map short day → full day name used by the DB column
  var DAY_FULL_NAME = {Mon:'Monday',Tue:'Tuesday',Wed:'Wednesday',Thu:'Thursday',Fri:'Friday',Sat:'Saturday',Sun:'Sunday'};
  var fullDay = DAY_FULL_NAME[day] || day;

  // Look up the Save button to disable it during the async flow. We
  // don't change the label until we get past PIN attribution — the
  // staff-picker modal is itself the visual signal that something is
  // happening, and a "Verifying…" label on a hidden button just hangs
  // there confusingly while the modal is open.
  var saveBtn = document.querySelector('#deliveryModal button[onclick*="saveDelivery"]');
  var prevLabel = saveBtn ? saveBtn.textContent : '';
  if (saveBtn) saveBtn.disabled = true;

  (async function() {
    try {
      var attr = await requirePinForAttribution('saving delivery schedule');
      // Got attribution. Now show "Saving…" so the user has a clear signal
      // during the DB call (which is the actual blocking part).
      if (saveBtn) saveBtn.textContent = 'Saving…';

      var row = {
        store: currentStore,
        day_of_week: fullDay,
        window_start: start,
        window_end: end,
        notes: note || null,
        edited_by_staff_id: attr.staff_id,
        edited_by_staff_name: attr.staff_name,
      };
      if (typeof DB !== 'undefined') {
        await DB.delivery.save([row]);
        dlog('[DB] Saved delivery for '+currentStore+' '+fullDay+' (by '+attr.staff_name+')');
      }

      // Success path: NOW update in-memory state, close modal, re-render rota.
      // This is the only path that mutates `deliveries`. No rollback to manage.
      if (!deliveries[day]) deliveries[day] = [];
      deliveries[day].push({time:start+'-'+end,note:note});
      closeDeliveryModal();
      renderCurrentRotaView();
      showToast('Delivery saved for '+fullDay+' ✓','success');

    } catch(e) {
      // Restore the button so the user can retry without losing their input.
      if (saveBtn) { saveBtn.disabled = false; saveBtn.textContent = prevLabel; }

      if (e && e.message === 'Attribution cancelled') {
        // User dismissed the staff picker / PIN pad. Clearer message than
        // before — explicit about WHY the delivery was not saved and that
        // the form values are still filled in.
        showToast('⚠️ Delivery NOT saved — you cancelled identity verification. Tap Save again to retry.', 'error');
        return;
      }
      console.warn('[DB] Delivery save failed:', e && e.message);
      showToast('❌ Could not save delivery: ' + ((e && e.message) || 'unknown error') + ' — please try again', 'error');
    }
  })();
}
schedule.saveDelivery = saveDelivery;

// v136.8 (accessibility audit, 16 Oct 2026): the delivery used to vanish from the screen BEFORE the PIN, and stayed
// gone when the PIN was cancelled (the screen said one thing, the database another, until a reload). Now nothing
// changes until the PIN succeeds and the database has taken the change; cancel or a failed write leaves it in place.
// Same shape as saveDelivery above: the success path is the only one that mutates `deliveries`.
function removeDelivery(day,idx){
  if(!deliveries[day]||!deliveries[day][idx])return;
  var target = deliveries[day][idx];
  // What the day will hold once this one is gone (computed, not applied yet).
  var remaining = deliveries[day].filter(function(d){ return d !== target; });

  // If there are still deliveries left for this day, upsert the first one;
  // if none, delete the row from DB.
  var DAY_FULL_NAME = {Mon:'Monday',Tue:'Tuesday',Wed:'Wednesday',Thu:'Thursday',Fri:'Friday',Sat:'Saturday',Sun:'Sunday'};
  var fullDay = DAY_FULL_NAME[day] || day;

  function applyRemoval() {
    var list = deliveries[day] || [];
    var at = list.indexOf(target);
    if (at !== -1) list.splice(at, 1);
    closeDeliveryModal();
    renderCurrentRotaView();
  }

  (async function() {
    try {
      var attr = await requirePinForAttribution('removing a delivery');
      if (typeof DB === 'undefined') { applyRemoval(); return; }
      if (!remaining.length) {
        await DB.delivery.remove(currentStore, fullDay);
        dlog('[DB] Deleted delivery for '+currentStore+' '+fullDay);
      } else {
        var remain = remaining[0];
        var parts = (remain.time || '').split('-');
        await DB.delivery.save([{
          store: currentStore,
          day_of_week: fullDay,
          window_start: parts[0] || null,
          window_end: parts[1] || null,
          notes: remain.note || null,
          edited_by_staff_id: attr.staff_id,
          edited_by_staff_name: attr.staff_name,
        }]);
        dlog('[DB] Updated delivery (after remove) for '+currentStore+' '+fullDay);
      }
      applyRemoval();   // only now, after the PIN and the database write
      showToast('Delivery removed','success');
    } catch(e) {
      if (e && e.message === 'Attribution cancelled') {
        // Nothing was changed: the delivery is still on screen and in the database.
        showToast('Delivery not removed: you cancelled the PIN','error');
        return;
      }
      console.warn('[DB] Delivery remove failed:', e && e.message);
      showToast('Could not remove the delivery. It is still there; please try again','error');
    }
  })();
}
schedule.removeDelivery = removeDelivery;
